export default "__VITE_PUBLIC_ASSET__e698d849__"